import {EDIT_MESSAGE_STARTED} from "../../reducers/editMessageReducer";


export const editMessageStarted = () =>{
    return {
        type: EDIT_MESSAGE_STARTED,
        payload: {}
    }
}